module.exports = __webpack_public_path__ + "static/img/tutoriales sin texto utopie-6.7977f656.jpg";